<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-07-30 20:19:36
--> 
<template>
  <div>
    <serialNumber></serialNumber>
  </div>
</template> 
 
<script>
import serialNumber from './serialNumber'
export default {
  components: {
    serialNumber
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>